import { Box, Chip, styled } from '@mui/material';
import { ReactElement } from 'react';

import logo from '../../style/pool-alpin-black.svg';

const Container = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    textAlign: 'center',
}));

const Logo = styled(Box)({
    display: 'inline-block',
    width: '200px',
    height: '63px',
    background: `url(${logo}) no-repeat center`,
    backgroundSize: 'contain',
});

const getPortalLabel = (redirectURL: string | null): string | null => {
    if (redirectURL?.includes('customer')) {
        return 'customer';
    }

    if (redirectURL?.includes('supplier')) {
        return 'supplier';
    }

    if (redirectURL?.includes('shop')) {
        return 'shop';
    }

    return null;
};

export const LoginLogo = ({ redirectURL }: { redirectURL: string | null }): ReactElement => {
    const label = getPortalLabel(redirectURL);

    return (
        <Container>
            <Logo />
            {/* Which door this is, in the same pill the rest of the app uses.
                On its own line: the logo is inline, and a chip beside it hangs
                off the wordmark instead of sitting under it. */}
            {label && (
                <Box>
                    <Chip size="small" label={label} sx={{ mt: '8px' }} />
                </Box>
            )}
        </Container>
    );
};
